module.exports = __webpack_public_path__ + "img/hero-rounded-bottom.910a2451.svg";